import { render } from "./MetadataInfo.vue?vue&type=template&id=1e40365b&scoped=true&ts=true"
import script from "./MetadataInfo.vue?vue&type=script&lang=ts"
export * from "./MetadataInfo.vue?vue&type=script&lang=ts"

import "./MetadataInfo.vue?vue&type=style&index=0&id=1e40365b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e40365b"]])

export default __exports__